import { ValidationContext } from "~app/common/validation/validationContext";
import { ValidationErrorLevels } from "~app/common/validation/ValidationErrorLevels";
import { ValidationScopes } from "~app/common/validation/ValidationScopes";
import { AtgardNaturvardesbedomningDTO } from "~app/features/virkeskop/models/naturvardesbedomning-models";
export class ForenkladRiskbedomningValidation {
    static init(nvbAccessor: () => AtgardNaturvardesbedomningDTO): ValidationContext {
        const context = new ValidationContext();
        context.create(ValidationScopes.spara).withRules([
            {
                errorLevel: ValidationErrorLevels.error,
                id: 1,
                applicable: () => nvbAccessor()?.faltbesokKravs,
                message: { text: "Datum för fältbesök måste anges" },
                model: () => nvbAccessor()?.faltbesokDatum,
                required: true,
                name: "faltbesokKravs"
            },
            {
                errorLevel: ValidationErrorLevels.error,
                id: 2,
                model: () => nvbAccessor()?.leverantorKontrolleratAvverkning,
                name: "leverantorKontrolleratAvverkning",
                required: true,
                message: { text: "Leverantör kontrollerat avverkning måste anges" }
            },
            {
                errorLevel: ValidationErrorLevels.error,
                id: 3,
                model: () => nvbAccessor()?.leverantorKontrolleratLaguppfyllnad,
                name: "leverantorKontrolleratLaguppfyllnad",
                required: true,
                message: { text: "Leverantör kontrollerat laguppfyllnad måste anges" }
            },
            {
                errorLevel: ValidationErrorLevels.error,
                id: 4,
                model: () => nvbAccessor()?.leverantorAccepterarPolicy,
                name: "leverantorAccepterarPolicy",
                required: true,
                message: { text: "Leverantör accepterar policy måste anges" }
            }
        ]);
        return context;
    }
}
